module.exports = __webpack_public_path__ + "img/antt-act-img1.90514ff3.png";